import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="mobile-search"
export default class extends Controller {
  connect() {
  }

  toggle() {
    const search = document.querySelector('.catalogue-header-search__form')
    search.classList.toggle('open')
  }
}
